import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { usePostHog } from "posthog-js/react";
import { useAuth } from "@/contexts/AuthContext";
import { POSTHOG_EVENTS } from "@/constants";

export function useStartEvaluation() {
  const navigate = useNavigate();
  const posthog = usePostHog();
  const { user } = useAuth();

  return useCallback(() => {
    posthog.capture(POSTHOG_EVENTS.START_EVALUATION);
    navigate(user ? "/companiile-mele" : "/auth");
  }, [navigate, posthog, user]);
}
